const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
];
const SESSION_KEY = "solvook_utm_params";
/**
 * URL 쿼리에서 UTM 파라미터를 추출하여 sessionStorage에 저장
 * - 이미 저장된 UTM이 있으면 무시 (최초 UTM 유지)
 */ export const captureUtmParams = (query)=>{
    if ("object" === "undefined") return;
    // 이미 저장된 UTM이 있으면 무시
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return;
    const utmParams = {};
    let hasUtm = false;
    for (const key of UTM_KEYS){
        const value = query[key];
        if (typeof value === "string" && value) {
            utmParams[key] = value;
            hasUtm = true;
        }
    }
    if (hasUtm) {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(utmParams));
    }
};
/**
 * sessionStorage에서 저장된 UTM 파라미터 반환
 */ export const getStoredUtmParams = ()=>{
    if ("object" === "undefined") return null;
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (!stored) return null;
    try {
        return JSON.parse(stored);
    } catch (e) {
        return null;
    }
};
/**
 * 저장된 UTM 파라미터를 Mixpanel super properties로 등록
 * - UTM이 있으면 등록, 없으면 이전에 등록된 UTM을 해제
 * - register()는 Mixpanel 쿠키에 저장되므로, 세션이 끝나면 명시적으로 해제해야 함
 */ export const registerUtmToMixpanel = ()=>{
    const utmParams = getStoredUtmParams();
    try {
        if (!window.mixpanel) return;
        if (utmParams) {
            window.mixpanel.register(utmParams);
        } else {
            // UTM이 없는 세션에서는 이전 세션의 UTM super properties 해제
            for (const key of UTM_KEYS){
                window.mixpanel.unregister(key);
            }
        }
    } catch (e) {
        ;
    }
};
